import HeaderImage from "../../assets/images/main_header.jpg";
import "./ContactsPage.css";
import {Breadcrumb} from "antd";
import {Link} from "react-router-dom";
import {FullscreenControl, Map, Placemark, RulerControl, YMaps, ZoomControl} from "@pbe/react-yandex-maps";

const ContactsPage = () => {


    return(
        <div className={"cp-container"}>
            <div className={"cp-container-image"}>
                <img src={HeaderImage} alt="Header Background" style={{width: "100%"}}/>
            </div>

            <div className="cp-header">
                <h1>Контакты</h1>
                <Breadcrumb
                    items={[
                        {
                            title: <Link to="/">Главная страница</Link>
                        },
                        {
                            title: <span>Контакты</span>,
                        },
                    ]}
                    className="cp-breadcrumb"
                />
                <div className="under-breadcrumb-divider"></div>
            </div>

            <div className={"cp-content"}>
                <YMaps>
                    <div className={"cp-content-section"}>
                        <h2>Отдел продаж</h2>
                        <p>
                            Телефон: <b>+7 (495) 108-66-28</b> <br/>
                        </p>
                        <p>
                            Адрес эл. почты: <b>contact@bryanskmel.ru</b> <br/>
                        </p>
                    </div>

                    <div className={"cp-content-section"}>
                        <h2>Офис в Погаре</h2>
                        <p>
                            Телефон: <b>+7 (48349) 2-35-33</b> <br/>
                            Адрес: пгт. Погар, Советская площадь 8, ООО "АгроТрейд"
                        </p>

                        {/*<YMaps>*/}
                        <Map
                            defaultState={{center: [52.554587, 33.266223], zoom: 16}}
                            width="100%"
                            height="40vh"
                        >
                            <Placemark defaultGeometry={[52.554587, 33.266223]}/>
                            <FullscreenControl/>
                            <RulerControl options={{float: "right"}}/>
                            <ZoomControl options={{float: "right"}}/>
                        </Map>
                        {/*</YMaps>*/}
                    </div>

                    <div className={"cp-content-section"}>
                        <h2>Производство</h2>
                        <p>
                            Адрес: Брянская область, р-н Погарский, п.Мирские, ул.Садовая д. 1А с1
                        </p>

                        <Map
                            defaultState={{center: [52.453346, 33.090728], zoom: 10}}
                            width="100%"
                            height="40vh"
                        >
                            <Placemark defaultGeometry={[52.453346, 33.090728]}/>
                            <FullscreenControl/>
                            <RulerControl options={{float: "right"}}/>
                            <ZoomControl options={{float: "right"}}/>
                        </Map>
                    </div>

                    <div className={"cp-content-section"}>
                        <h2>Генеральный директор</h2>
                        <p>
                            Сапранцов Александр Алексеевич <br/>
                            Телефон: <b>+7 (48349) 2-35-33</b> <br/>
                        </p>
                    </div>
                </YMaps>
            </div>


        </div>
    )
}

export default ContactsPage;